// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__gme7b","mainHeader":"Header_mainHeader__goSq4","imgContainer":"Header_imgContainer__dfHKI"};